export default __webpack_public_path__ + "media/images/icons/2-flight-f18bacbcea1061f95f99801930489040.png";